import { Injectable } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { TealiumAnalyticsService } from '@ddt-web/analytics';
import { ERROR_SEVERITY } from '@ddt-web/config';

import { AbstractErrorHandlerService } from './abstract-error-handler.service';
import { ErrorHelperService } from './error-helper.service';
import { ErrorPopupService } from './error-popup.service';

@Injectable()
export class CommonErrorHandlerService extends AbstractErrorHandlerService {
	protected trackErrorMessage: string;

	constructor(
		protected contentService: ContentService,
		protected errorPopupService: ErrorPopupService,
		protected tealiumAnalyticsService: TealiumAnalyticsService,
		protected errorHelperService: ErrorHelperService
	) {
		super(contentService, errorPopupService, tealiumAnalyticsService, errorHelperService);
	}

	public handleError(error): void {
		this.errorSeverity = ERROR_SEVERITY.WARNING;
		this.trackErrorMessage = 'generalerror';
		if (error instanceof TypeError) {
			console.error('There was a Type error.', error.message, error);
			this.trackErrorMessage = 'typeerror';
			this.tealiumAnalyticsService.trackError(this.trackErrorMessage, this.errorSeverity);
		} else if (error instanceof Error) {
			console.error('There was a general error.', error.message, error);
			this.tealiumAnalyticsService.trackError(this.trackErrorMessage, this.errorSeverity);
		} else {
			this.nextHandler.handleError(error);
		}
	}
}
